export default {
  text: {
    order_cancelled: 'Ordine annullato - Autista non disponibile',
    wolt_support: 'Domande? Chiama Wolt direttamente <underline>{{phone_number}}</underline>',
    order_not_confirmed: '<strong>URGENTE:</strong> Accetta o rifiuta questo ordine immediatamente',
  },
  labels: {
    dummy_order: 'Ordine di prova',
    items_one: '{{count}} articolo',
    items_other: '{{count}} articoli',
    needs_acceptance: 'In attesa di accettazione',
    driver_pending: 'In attesa del corriere',
    today: 'Oggi',
    driver_assigned: 'Corriere assegnato',
    complete: 'Completato',
  },
  buttons: {
    complete_order: 'Segna come completato',
    looking_for_driver: 'Ricerca corriere...',
    click_to_remove: 'Clicca per rimuovere',
  },
};
